import React from "react";
import { connect } from 'react-redux';
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import moment from "moment";
import { withRouter } from 'react-router-dom';
import { getPendingApprovalDetails } from "../Actions/ApproverScreenAPI";
import { getEquipmentDetails } from "../Actions/ApproverScreenAPI";
import PendingApprovalDetails from "./PendingApprovalDetails";

class ApprovalsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    componentDidMount() {
        const { match, dispatch } = this.props;
        const { params } = match;
        const { id } = params;
        dispatch(getPendingApprovalDetails(id));
        dispatch({ type: "SubBannerTitle", data: "Ship Equipments List" });
    }

    showEquipment(item) {
        const { match, dispatch, history} = this.props;
        const { params } = match;
        const { id } = params;
        this.setState({ item: item }, () => {
            dispatch({ type: "ShowSidePan", data: true });
            dispatch({ type: "equipementData", data: item });
            history.push(`/Home/PendingApprovals/${id}/Equipments/${item.shipEquipmentId}`);
        });
        if(this.props.showSidePane){
            dispatch(getEquipmentDetails(item.shipEquipmentId));
        }
    }

    hideSidePanel() {
        const { dispatch, history } = this.props;;
        dispatch({ type: "ShowSidePan", data: false });
        history.push(`/Home/PendingApprovals`);
    }
    render() {
        const { EquipementList, showSidePane,t } = this.props;
        return (
            <div className={showSidePane ? "d-flex col-sm-12 col-md-6 col-lg-6 mobile float-left" : "pb-3"}>
                <div className="full-height">
                    <div className="resource-list-auth-date col-lg-12 row pt-3 pr-0">
                        <div className="col-lg-12  search-filter-box pt-0 pr-0">
                            {showSidePane ?
                                <></> :
                                <div className="ml-4 mb-3" style={{ paddingRight: "40px" }}>
                                    <button
                                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                        onClick={() => this.hideSidePanel()}
                                    >
                                        &larr; {t("CommonText.Back")}
                                    </button>
                                </div>
                            }
                            <div className="panel-box ml-4 pb-2">
                                <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                    <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                                        <h5 className="card-title ml-2 mt-2 f2" style={{ color: "092a51" }}> {t("PendingApprovalScreenContent.EquipmentsList")}</h5>
                                    </div>
                                </div>
                                {EquipementList && EquipementList.length ? EquipementList.map((item, index) => {
                                    if (!item.isDeleted) {
                                        return (
                                            <div className="card m-3 mb-2" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
                                                <div className="p-3">
                                                    <div className="resource-list-auth-date">

                                                        <div className="row">
                                                            <div className={"col-sm-9 col-md-10 col-9 m-auto"}>
                                                                <div className="row">
                                                                    <div className="col-sm-12 col-md-12 py-2">
                                                                        <h6 className="resource-list-title m-0">
                                                                            {item.equipmentName}
                                                                        </h6>
                                                                    </div>
                                                                    <div className={"col-md-4 col-sm-6 py-2"}>
                                                                        <span>
                                                                            <strong>{t("CategoryScreen.Title")}: </strong>
                                                                            {item.category}
                                                                        </span>
                                                                    </div>
                                                                    <div className={"col-md-4 col-sm-6 py-2"}>
                                                                        <span>
                                                                            <strong> {t("ComplianceandBudgetScreen.Type")}: </strong>
                                                                            {item.equipmentType}
                                                                        </span>
                                                                    </div>
                                                                    <div className={"col-md-4 col-sm-6 py-2"}>
                                                                        <span>
                                                                            <strong>{t("ShipEquipmentStatusScreen.ManufacturingDate")}: </strong>
                                                                            {item.manufacturingDate ? moment(item.manufacturingDate).format("YYYY-MM-DD") : ""}
                                                                        </span>
                                                                    </div>
                                                                    <div className={"col-md-4 col-sm-6 py-2"}>
                                                                        <span>
                                                                            <strong>{t("ShipEquipmentStatusScreen.Quantity")}: </strong>
                                                                            {item.quantity >0 ? item.quantity:""}
                                                                        </span>
                                                                    </div>
                                                                    <div className={"col-md-4 col-sm-6 py-2"}>
                                                                        <span>
                                                                            <strong>{t("ShipEquipmentStatusScreen.Unit-Quantity")}: </strong>
                                                                            {item.unit?item.unit:""}
                                                                        </span>
                                                                    </div>
                                                                    <div className={"col-md-4 col-sm-6 py-2"}>
                                                                        <span>
                                                                            <strong>{t("EquipmentManagementScreenContent.Capacity/Size")}: </strong>
                                                                            {item.capacity}
                                                                        </span>
                                                                    </div>
                                                                    {item.equipmentName !=="" && item?.equipmentName.toLowerCase().includes("lifeboat")?
                                                                    <>
                                                                    <div className={"col-md-4 col-sm-6 py-2"}>
                                                                   <span>
                                                                     <strong>{t("EditEquipmentScreenContent.LifeboatMake")} :{" "} </strong>
                                                                     {item.lifeboatMake? item.lifeboatMake:""}{" "}
                                                                   </span>
                                                                 </div>
                                                                 <div className={"col-md-4 col-sm-6 py-2"}>
                                                                   <span>
                                                                     <strong> {t("EditEquipmentScreenContent.Davit/winchMake")} :{" "} </strong>
                                                                     {item.davitWinchMake?item.davitWinchMake:""}{" "}
                                                                   </span>
                                                                 </div>
                                                                 <div className={"col-md-4 col-sm-6 py-2"}>
                                                                   <span>
                                                                     <strong> {t("EditEquipmentScreenContent.LifeboatModel")} :{" "} </strong>
                                                                     {item.lifeboatModel?item.lifeboatModel:""}{" "}
                                                                   </span>
                                                                 </div>
                                                                 <div className={"col-md-6 col-sm-6 py-2"}>
                                                                   <span>
                                                                     <strong> {t("EditEquipmentScreenContent.LifeboatRelease")} :{" "} </strong>
                                                                     {item.lifeboatRelease?item.lifeboatRelease:""}{" "}
                                                                   </span>
                                                                 </div>
                                                                   </>
                                                                    :item.equipmentName !=="" && item?.equipmentName.toLowerCase().includes("rescue boat")?
                                                                    <>
                                                                       <div className={"col-md-4 col-sm-6 py-2"}>
                                                                    <span>
                                                                      <strong>{t("EditEquipmentScreenContent.rescueboatMake")} :{" "} </strong>
                                                                      {item.rescueboatMake?item.rescueboatMake:""}{" "}
                                                                    </span>
                                                                  </div>
                                                                  <div className={"col-md-4 col-sm-6 py-2"}>
                                                                    <span>
                                                                      <strong>{t("EditEquipmentScreenContent.rescueboatDavit/winchMake")} :{" "} </strong>
                                                                      {item.rescueboatdavitMake?item.rescueboatdavitMake:""}{" "}
                                                                    </span>
                                                                  </div>
                                                                  <div className={"col-md-4 col-sm-6 py-2"}>
                                                                    <span>
                                                                      <strong>{t("EditEquipmentScreenContent.rescueboatModel")} :{" "} </strong>
                                                                      {item.rescueboatModel?item.rescueboatModel:""}{" "}
                                                                    </span>
                                                                  </div>
                                                                  <div className={"col-md-6 col-sm-6 py-2"}>
                                                                    <span>
                                                                      <strong> {t("EditEquipmentScreenContent.rescueboatRelease")} :{" "} </strong>
                                                                      {item.rescueboatRelease?item.rescueboatRelease:""}{" "}
                                                                    </span>
                                                                  </div>
                                                                    </>
                                                                    :<>
                                                                    <div className={"col-md-4 col-sm-6 py-2"}>
                                                                        <span>
                                                                            <strong>{t("ShipEquipmentStatusScreen.Make")}: </strong>
                                                                            {item.make?item.make:""}
                                                                        </span>
                                                                    </div>
                                                                    <div className={"col-md-4 col-sm-6 py-2"}>
                                                                        <span>
                                                                            <strong>{t("ShipEquipmentStatusScreen.Model")}: </strong>
                                                                            {item.model?item.model:""}
                                                                        </span>
                                                                    </div></>}
                                                                    
                                                                    <div className={"col-md-6 col-sm-6 py-2"}>
                                                                        <span>
                                                                            <strong>{t("EquipmentServiceTypes.Status")}: </strong>
                                                                            {item.status}
                                                                        </span>
                                                                    </div>
                                                                    <div className={"col-md-6 col-sm-6 py-2"}>
                                                                        <span>
                                                                            <strong>{t("PendingApprovalScreenContent.Requestedby")}: </strong>
                                                                            {item.requestedBy}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={"col-sm-3 col-md-2 col-3 m-auto"}>
                                                                <div
                                                                    className="text-right"
                                                                    style={{ marginLeft: "-5px",cursor:"pointer" }}
                                                                >
                                                                    <i
                                                                        className="fa fa-eye fa-2x fa-lg px-1 m-1 mr-3"
                                                                        onClick={() => this.showEquipment(item)}
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                }) :
                                    <div className="card m-3" style={{ overflow: "hidden", position: "relative" }}>
                                        <div className="container">
                                            <h6 className="resource-list-title no-item-card">
                                            {t("PendingApprovalScreenContent.NoEquipments")}
                                            </h6>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {/* {showSidePane ?
                    <PendingApprovalDetails
                        item={this.state.item}
                    />
                    : <></>
                } */}
            </div>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        EquipementList: state.ApproverScreenReducer.ApprovalDetails || [],
        showSidePane: state.SidePanReducer.sidePan || false,

    }
}
export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(ApprovalsList)));
